var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceActionsLink = function SvgInterfaceActionsLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7a5 5 0 0 0 0 10h4v-2H6a3 3 0 1 1 0-6h4V7zm8 0v2h4a3 3 0 1 1 0 6h-4v2h4a5 5 0 0 0 0-10zm-7 4v2h10v-2z"
  })));
};
export default SvgInterfaceActionsLink;